module.exports = __webpack_public_path__ + "assets/img/2eee-cx.svg";